export default function RootedWordmark({
  size = 'sm',
  showPublisher = false,
  color,
  publisherColor,
}) {
  const fontSize = size === 'lg' ? 42 : size === 'md' ? 28 : 13;
  const tracking = size === 'lg' ? '0.15em' : '0.12em';
  const textColor = color || '#1B1814';
  const subColor = publisherColor || '#A67C3A';

  return (
    <div style={{ textAlign: 'center' }}>
      <p
        style={{
          fontSize,
          fontFamily: 'Georgia, serif',
          fontWeight: 300,
          color: textColor,
          letterSpacing: tracking,
          textTransform: 'uppercase',
          margin: 0,
          lineHeight: 1,
        }}
      >
        Rooted
      </p>
      {showPublisher && (
        <p
          style={{
            fontSize: 10,
            fontFamily: 'Arial, sans-serif',
            color: subColor,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            margin: '4px 0 0',
            opacity: 0.7,
          }}
        >
          by Golden Fox Publishing
        </p>
      )}
    </div>
  );
}
